module.exports = __webpack_public_path__ + "img/monetize-laptop.0ac7a24c.png";